/* unplugin-vue-components disabled */import { render } from "./tasks.vue?vue&type=template&id=fbae6b34&scoped=true"
import script from "./tasks.vue?vue&type=script&setup=true&lang=js"
export * from "./tasks.vue?vue&type=script&setup=true&lang=js"

import "./tasks.vue?vue&type=style&index=0&id=fbae6b34&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbae6b34"],['__file',"src/pages/settings/admin/tasks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fbae6b34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fbae6b34', __exports__)) {
    api.reload('fbae6b34', __exports__)
  }
  
  module.hot.accept("./tasks.vue?vue&type=template&id=fbae6b34&scoped=true", () => {
    api.rerender('fbae6b34', render)
  })

}


export default __exports__